var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},[_c('label',[_c('input',{attrs:{"type":"checkbox"},on:{"click":_vm.clickHandler}})]),(_vm.$slots.default)?_c('span',{staticClass:"label"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }